module.exports = __webpack_public_path__ + "static/media/Option Naming Convention.dc1e94ee.png";